import { DateTime } from 'luxon';
import styled from 'styled-components';

import { useGlobalStore } from '../../state/globalStore';
import { getTimeZone, isSameDate as isSame } from '../../utils/helper';

export const EventDate = () => {
  const isEventDateVisible = useGlobalStore((state) => state.leadCapture.isEventDateVisible);
  const { eventDate: eventDateStyle } = useGlobalStore(
    (state) => state.leadCapture.nonEditableTextStyle,
  );
  const schedule = useGlobalStore((store) => store.entity.schedule);
  const start = DateTime.fromISO(schedule?.startTime);
  const end = DateTime.fromISO(schedule?.endTime);
  const isSameDate = isSame(new Date(schedule?.startTime), new Date(schedule?.endTime));
  const locale = navigator.language || 'en-US';

  const isEventDateInvalid = !(isEventDateVisible && start.isValid && schedule);

  if (isEventDateInvalid) {
    return null;
  }

  return isSameDate ? (
    <DateDisplay color={eventDateStyle.color}>
      {`${start.toFormat('cccc, MMMM d, yyyy')} `}
      <div>
        <span>
          {start.toFormat('h:mm')} {start.toFormat('a').toLowerCase()}
        </span>
        {end.isValid ? (
          <>
            <span> - </span>
            <span>
              {end.toFormat('h:mm')} {end.toFormat('a').toLowerCase()}
            </span>
            <span>{` ${getTimeZone(locale)}`}</span>
          </>
        ) : (
          <span>{` ${getTimeZone(locale)}`}</span>
        )}
      </div>
    </DateDisplay>
  ) : (
    <DateDisplay color={eventDateStyle.color}>
      {start.toFormat('cccc, MMMM d, yyyy')} at {start.toFormat('h:mm')}{' '}
      {start.toFormat('a').toLowerCase()}
      <span>{` ${getTimeZone(locale)}`}</span>
      {end.isValid && (
        <>
          <div>to</div>
          <span>
            {end.toFormat('cccc, MMMM d, yyyy')} at {end.toFormat('h:mm')}{' '}
            {end.toFormat('a').toLowerCase()}
          </span>
          <span>{` ${getTimeZone(locale)}`}</span>
        </>
      )}
    </DateDisplay>
  );
};

const DateDisplay = styled.div<{ color: string }>`
  border: solid 2px transparent;
  color: ${({ color }) => color};
  font-size: 16px;
  font-weight: 700;
`;
